<div class="uk-container uk-container-large">
  <h3 class="primary-color uk-margin-top padding-left-40 uk-margin-remove-bottom"><b>MON ESPACE</b></h3>
  <h2 class="uk-margin-remove padding-left-40">Accueil</h2>
  <div class="uk-grid uk-child-width-1-3 uk-margin-remove-top">
    <div class="responsive-bloc" *ngFor="let button of buttons; index as i">
      <ng-container *ngIf="button.component === 'cart'; else defaultButton">
        <a class="neutral-link" [routerLink]="button.routerLink">
          <ags-cart-profile-button
            [icon]="button.icon"
            [title]="button.title"
            [subtitle]="button.subtitle"
            [waitLink]="button.waitLink"
            (outputLink)="changeRouterLink($event, i)"
          >
          </ags-cart-profile-button>
        </a>
      </ng-container>
      <ng-template #defaultButton>
        <a class="neutral-link" [routerLink]="button.routerLink">
          <ng-container *ngIf="button.component === 'deconnexion'">
            <div (click)="signout()">
              <ng-container *ngTemplateOutlet="coreButton"></ng-container>
            </div>
          </ng-container>
          <ng-container *ngIf="button.component !== 'deconnexion'">
            <ng-container *ngTemplateOutlet="coreButton"></ng-container>
          </ng-container>
        </a>
      </ng-template>
      <ng-template #coreButton>
        <ags-argalis-apps-profile-button
          [icon]="button.icon"
          [title]="button.title"
          [subtitle]="button.subtitle">
        </ags-argalis-apps-profile-button>
      </ng-template>
    </div>
  </div>
</div>
